<script>
    import R, {LOADER} from "../lib/requests";
    import Alert from "../stores/alerts";
    import Notifier from "../stores/notifier";
    import PageHeader from "../components/PageHeader.svelte";
    import ClientControl from "../components/controls/ClientControl.svelte";
    import AnalysesSelectControl from "../components/controls/AnalysesSelectControl.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";
    import SampleTypeControl from "./SampleTypeControl.svelte";

    let client = null;
    let stats = {
        client_id: 112,
        type_value: null,
        date_from: null,
        date_to: null,
        analyses_ids: [],
    }
    let analyses = [];
    let data = null;


    const load = () => {
        const onSuccess = result => {
            data = result;
        }

        const onFailure = err => {

        };

        if (!stats.client_id) {
            Alert.warning("Στατιστικά", "Ορίστε πελάτη για αποτελέσματα.");
            return;
        }

        if (analyses.length == 0) {
            Alert.warning("Στατιστικά", "Ορίστε παραμέτρους για αποτελέσματα.");
            return;
        }

        stats.analysis_ids = analyses.map(item => (item.id));

        R.handle(R.sample.cloudAnalyses, stats, onSuccess, onFailure, LOADER.POPUP);
    }

    const clearSearch = () => {
        client = null;
        stats.client_id = null;
        stats.type_value = null;
        stats.date_from = null;
        stats.date_to = null;
        stats.analyses = [];

        // sampleTypeInfo = null;
        analyses = [];
    }


    const onClientChange = ({detail}) => {
        stats.client_id = detail ? detail.id : null;
    }

    const onTypeChange = ({detail}) => {
        if (stats.type_value != detail) {
            stats.type_value = detail;
        }
    }

    const onAnalysisSelect = ({detail}) => {
        let item = analyses.find(x => x.id == detail.id);
        if (!item) {
            analyses = [{id: detail.id, code: detail.code, name: detail.name_el}, ...analyses];
        }
        console.log(analyses)
    }

    const onAnalysesRemove = (id) => {
        analyses = analyses.filter(x => x.id != id);
    }

    const copyToClipboard = async (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.target.select();

        try {
            await navigator.clipboard.writeText(event.target.value);
            Notifier.showMessage("Image file name copied to clipboard");
        } catch (e) {
            Notifier.showError("Copy to clipboard failed!");
        }
    }

    const copyTableToClipboard = async () => {
        const table = document.getElementById("analysesTable");
        const rows = Array.from(table.querySelectorAll("tr"));

        const text = rows
            .map(row => {
                const cells = Array.from(row.querySelectorAll("th, td"));
                return cells
                    .map(cell => cell.innerText.trim().replace(/\n/g, " "))
                    .join("\t");
            })
            .join("\n");

        try {
            await navigator.clipboard.writeText(text);
            Notifier.showMessage("Τα αποτελέσματα αντιγράφτηκαν στο πρόχειρο");
        } catch (err) {
            Notifier.showError("Η αντιγραφή στο πρόχειρο απέτυχε!");
        }
    }


    // client = {
    //     code: "3",
    //     company: "Source Development",
    //     email: "harrysnikoloudakis@gmail.com",
    //     id: 3,
    //     name: "Χάρης Νικολουδάκης",
    //     phone: "2815106377"
    // }
    // stats.client_id = 112;
    // stats.date_from = '2023-10-01';
    // analyses = [{id: '2', code: '0002', name: 'Ολική χλωρίδα στους 22°C (cfu/ml)'}, {
    //     id: '1',
    //     code: '0001',
    //     name: 'Ολική χλωρίδα στους 36°C (cfu/ml)'
    // }];
</script>

<PageHeader title="Στατιστικά Pdf"/>
<div class="row">
    <div class="col-xl-3 col-lg-4">
        <div class="panel panel-simple p-2 mb-5">
            <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-6">
                    <div class="form-group">
                        <label>Πελάτης</label>
                        <ClientControl bind:client={ client } allowEdit={ false } on:change={ onClientChange }/>
                    </div>
                </div>
                <div class="col-xl-12 col-lg-12 col-md-6">
                    <div class="form-group">
                        <label>Είδος δείγματος</label>
                        <SampleTypeControl clientId="{ stats.client_id }" value="{ stats.type_value }"
                                           on:change={ onTypeChange }/>
                    </div>
                </div>
                <div class="col-xl-12 col-lg-12 col-md-6">
                    <div class="form-group">
                        <label>Παράμετροι</label>
                        <AnalysesSelectControl on:select={ onAnalysisSelect }/>
                        {#if analyses.length}
                            <ul class="list-group analyses-list-group mt-1">
                                {#each analyses as item}
                                    <li class="list-group-item d-flex align-items-center position-relative px-2">
                                        <span class="code">{ item.code }</span>
                                        { item.name }
                                        <button class="btn-reset remove" title="αφαίρεση ανάλυσης"
                                              on:click={ () => onAnalysesRemove(item.id) }>
                                            <AppIcon icon="x" size="16"/>
                                        </button>
                                    </li>
                                {/each}
                            </ul>
                        {/if}
                    </div>
                </div>
                <div class="col-xl-12 col-lg-12 col-md-6">
                    <label>Ημερομηνία</label>
                    <div class="row">
                        <div class="col-6">
                            <div class="form-group">
                                <input type="date" class="form-control" bind:value="{ stats.date_from }">
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-group">
                                <input type="date" class="form-control" bind:value="{ stats.date_to }">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <button class="btn btn-default btn-block" on:click={ clearSearch }>ΚΑΘΑΡΙΣΜΟΣ</button>
                </div>
                <div class="col-6">
                    <button class="btn btn-outline btn-block" on:click={ load }>ΑΠΟΤΕΛΕΣΜΑΤΑ</button>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-9 col-lg-8">
        {#if data != null}
            {#if data.rows.length === 0}
                <div class="alert alert-info">
                    Δεν βρέθηκαν αποτελέσματα.
                </div>
            {:else}
                <div class="legend mb-3">
                    Αποτελέσματα
                    <button class="btn btn-default btn-sm" title="αντιγραφή στο πρόχειρο" on:click={copyTableToClipboard}>
                        <AppIcon icon="copy" size="16"/>
                    </button>
                </div>
                <div class="table-wrapper">
                    <table id="analysesTable">
                        <thead>
                        <tr>
                            {#each data.columns as column}
                                <th>{column}</th>
                            {/each}
                        </tr>
                        </thead>
                        <tbody>
                        {#each data.rows as row}
                            <tr>
                                {#each data.columns as column}
                                    <td>{row[column] ?? ''}</td>
                                {/each}
                            </tr>
                        {/each}
                        </tbody>
                    </table>
                </div>
            {/if}
        {/if}
    </div>
</div>

<style>
    /*.table-stats tr td {*/
    /*    padding: 10px;*/
    /*}*/

    /*.table-stats .th {*/
    /*    font-size: .8rem;*/
    /*    font-weight: normal;*/
    /*    letter-spacing: 1px;*/
    /*    color: #999;*/
    /*    width: 220px;*/
    /*}*/

    /*.table-stats td.data {*/
    /*    width: calc(50% - 220px);*/
    /*}*/

    /*.table-stats tr.blank-separator {*/
    /*    background: #f2f6f8;*/
    /*}*/

    /*.table-stats tr.blank-separator td {*/
    /*    height: 15px;*/
    /*    border-left: 1px solid #f2f6f8;*/
    /*    border-right: 1px solid #f2f6f8;*/
    /*    padding: 0;*/
    /*}*/

    /*.table-stats tr.blank-separator:last-child td {*/
    /*    border-bottom: 1px solid #f2f6f8;*/
    /*}*/

    /*.table-stats tr.separator td {*/
    /*    height: 2px;*/
    /*    background: #c6d2d9;*/
    /*    padding: 0;*/
    /*}*/


    .pdf-container {
        width: 100%;
    }

    .analyses-list-group li .code {
        display: inline-block;
        margin-right: 10px;
    }

    .analyses-list-group li .remove {
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
        cursor: pointer;
        padding: 5px;
    }

    .sample-info-codes {
        max-height: 192px;
        overflow-y: auto;
    }

    @media (min-width: 992px) and (max-width: 1199px) {
        .pdf-container {
            height: calc(100vh - 170px);
        }
    }

    @media (min-width: 1200px) {
        .pdf-container {
            height: calc(100vh - 200px);
        }
    }


    .table-wrapper {
        overflow-x: auto;
        max-width: 100%;
    }

    table {
        border-collapse: collapse;
        width: 100%;
        min-width: 1400px;
    }

    th,
    td {
        border: 1px solid #ddd;
        padding: 8px;
        text-align: left;
        vertical-align: top;
        white-space: nowrap;
    }

    th {
        background: #f5f5f5;
        font-weight: 600;
    }

    tbody tr:nth-child(even) {
        background: #fafafa;
    }
</style>


